import cookieUtil from 'tradera-utils/cookie';
import { resolveCode, resolveCurrency } from './helpers';

export default initData => {
    const enabled =
        initData &&
        initData.featureSwitches &&
        initData.featureSwitches['multi-currency'] &&
        initData.memberCountry !== 'Sverige';
    const currencies = initData.currencies || [];
    const initialCurrencyCode = resolveCode(
        enabled,
        cookieUtil.readCookie('preferred_currency'),
        currencies
    );

    return {
        enabled,
        currencies,
        preferredCurrency: resolveCurrency(
            enabled,
            initialCurrencyCode,
            currencies
        )
    };
};
